
import * as React from 'react';
import { IDs } from '../../../helpers/IDs';
import { getKennzahlenVerfuegbar } from '../../../main/functions/getKennzahlenVerfuegbar';
import { getFilteredKennzahlen } from './getFilteredKennzahlen';

interface KennzahlenAuswahlProps extends React.ClassAttributes<any> {
    jahr?: number;
    data: any;
    onKennzahlChange: (kuerzel: string) => void;
    kennzahlSelected: string;
    fontSize?: number;
    showAll: boolean;
    padding?: number;
    width?: number;
    label?: string;
    disabled?: boolean;
    changeInvalidEkzSel?: boolean;
}

interface KennzahlenAuswahlState {
    dummy?: any;
}

export class KennzahlenAuswahl extends React.Component<KennzahlenAuswahlProps, KennzahlenAuswahlState> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render(): JSX.Element {
        const { jahr, data, showAll, padding, label, fontSize, width, disabled, kennzahlSelected, changeInvalidEkzSel, onKennzahlChange } = this.props;
        const kennzahlen = data[IDs.ENT_KENNZAHLEN_DEFINTION];
        const kennzahlen_berechnet = { ...data[IDs.KENNZIFFERN_BERECHNET] };
        const kz_verfuegbar = getKennzahlenVerfuegbar(kennzahlen_berechnet, jahr);
        if (!kennzahlen) {
            return <div>'Fehler: Kennzahlen fehlen'</div>;
        }
        const kennzahlenFiltered = getFilteredKennzahlen(jahr, data, showAll);

        if (changeInvalidEkzSel && kennzahlSelected && kennzahlenFiltered.length > 0 && !kennzahlenFiltered.find((k: any) => k.kuerzel === kennzahlSelected)) {
            onKennzahlChange(kennzahlenFiltered[0].kuerzel);
        }

        return (
            <div style={{ padding: (padding || padding === 0) ? padding + 'px' : '3px' }}>
                {label && <b style={{ color: '#888', fontSize: fontSize && fontSize + 'px' }}>
                    {label} &nbsp;</b>}
                <select
                    style={{
                        fontSize: fontSize && `${fontSize}px`, maxWidth: width ? `${width}px` : 190,
                        maxHeight: 'var(--formfields-compact-height)', minHeight: 'var(--formfields-compact-height)'
                    }}
                    value={kennzahlSelected}
                    onChange={(evt: any) => onKennzahlChange(evt.target.value)}
                    disabled={disabled}
                >
                    {kennzahlenFiltered.map((k: any, idx: number) => {
                        return (k.is_berechnet && k.is_berechnet === 1) ? <option
                            key={'opt_b_' + idx}
                            value={k.kuerzel}
                            style={{
                                backgroundColor: !kz_verfuegbar[k.kuerzel] ? '#FAA' :
                                    kz_verfuegbar[k.kuerzel] === 1 ? '#FFC' : '#AFA'
                            }}
                        >
                            &#x192; {k.name}
                        </option> :
                            <option
                                key={'opt_n_' + idx}
                                value={k.kuerzel}
                                style={{
                                    backgroundColor: !kz_verfuegbar[k.kuerzel] ? '#FAA' :
                                        kz_verfuegbar[k.kuerzel] === 1 ? '#FFC' : '#AFA'
                                }}
                            >
                                &#9998; {k.name}
                            </option>;
                    })}
                </select>
            </div>
        );
    }
}
